import {h} from "preact";
import Config from "../../config";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default function Footer() {
	return <footer class="font-sans bg-harif-800 text-white">
	    {!Config.customConfig.hideProvidersLogos && <FooterRow>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/betsoft_logo.svg")} class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/endorphina_logo.svg")} class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/evo_logo.svg")} class="h-8" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/gameart_negative_logo.svg")} class="h-8" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/playngo_logo.svg")} class="h-8" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/novomatic.png" class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/pragmatic.png" class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/quickspin.png" class="h-12" /></FooterPaddedCell>
		</FooterRow>}
	    {!Config.customConfig.hideProvidersLogos && <FooterRow>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/ainsworth.png" class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/amatic.png" class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/tomhorn_logo.svg")} class="h-10" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/vivogaming_logo.svg")} class="h-10" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/aristocrat.png" class="h-12" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src="https://www.babamonkey.eu/cached/img/bomba.png" class="h-12" /></FooterPaddedCell>
		</FooterRow>}
	    <FooterRowSeparated>
			<FooterPaddedCellFixed>
				<FooterNavHeader>ABOUT</FooterNavHeader>
				<FooterLinksContainer>
					<FooterLink href="/content/main/about">About us</FooterLink>
					<FooterLink href="/content/terms/privacy">Privacy Policy</FooterLink>
					<FooterLink href="/content/terms/gambling">Responsible Gaming</FooterLink>
					<FooterLink href="/contacts">Contact us</FooterLink>
				</FooterLinksContainer>
			</FooterPaddedCellFixed>
			<FooterPaddedCellFixed>
				<FooterNavHeader>INFORMATION</FooterNavHeader>
				<FooterLinksContainer>
					<FooterLink href="/content/terms/conditions">Terms & Conditions</FooterLink>
					<FooterLink>FAQ</FooterLink>
					<FooterLink href="/content/terms/sport-rules">Betting Rules</FooterLink>
					<FooterLink href="/content/products/sportsbook">Betting Information</FooterLink>
				</FooterLinksContainer>
			</FooterPaddedCellFixed>
			<FooterPaddedCellFixed>
				<FooterNavHeader>SPORTS</FooterNavHeader>
				<FooterLinksContainer>
					<FooterLink href="/live">Live betting</FooterLink>
					<FooterLink href="/prematch/1">Football</FooterLink>
					<FooterLink href="/prematch/3">Basketball</FooterLink>
					<FooterLink href="/prematch/2">Tennis</FooterLink>
					<FooterLink href="/prematch/21">Volleyball</FooterLink>
				</FooterLinksContainer>
			</FooterPaddedCellFixed>
			<FooterPaddedCellFixed>
				<FooterNavHeader>PLAY NOW</FooterNavHeader>
				<FooterLinksContainer>
					<FooterLink href="/virtual">Virtual</FooterLink>
					<FooterLink href="/special-games">Special Games</FooterLink>
				</FooterLinksContainer>
			</FooterPaddedCellFixed>
		</FooterRowSeparated>
		<FooterRow>
			<FooterPaddedCell><BWHoverImage src={Config.logourl} class="h-10" /></FooterPaddedCell>
		</FooterRow>
		<FooterRow>
			<div class="w-64 text-center">
				<FooterLink href="/contacts"><span class="text-sm"><Trans>Affiliates</Trans></span></FooterLink>
			</div>
			<div class="w-64 text-center">
				<FooterLink href="/contacts"><span class="text-sm"><Trans>Complaints</Trans></span></FooterLink>
			</div>
			<div class="w-64 text-center">
				<FooterLink href="/user/payment-gateway/deposit"><span class="text-sm"><Trans>Deposits and Withdrawals</Trans></span></FooterLink>
			</div>
		</FooterRow>
		<FooterRow>
			<p class="text-xs text-center text-accent-700 px-4">
				<Trans>Accedendo, o continuando a utilizzare o navigare in questo sito, acconsenti al nostro utilizzo di determinati cookie per migliorare la tua esperienza con noi. Utilizziamo solo cookie che miglioreranno la tua esperienza e non interferiranno con la tua privacy.</Trans>
				<br />
				<Trans>Consulta la nostra <a href="#">Cookie Policy</a> per ulteriori informazioni sul nostro utilizzo dei cookie e su come puoi disabilitarli o gestirli se lo desideri.</Trans>
			</p>
		</FooterRow>
	    <FooterRow>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/21plus_logo.svg")} class="h-6" /></FooterPaddedCell>
			<FooterPaddedCell><BWHoverImage src={require("url:../../assets/img/logo_provider/gt-logo.svg")} class="h-10" /></FooterPaddedCell>
		</FooterRow>
	</footer>;
}

const FooterRow = (props) => <div class="flex justify-center items-center py-6">{props.children}</div>
const FooterPaddedCell = (props) => <div class="px-2">{props.children}</div>

const FooterRowSeparated = (props) => <div class="shrink-0 grow-0 flex flex-wrap gap-4 justify-center py-6 border-t border-b border-harif-950">{props.children}</div>
const FooterPaddedCellFixed = (props) => <div class={"w-44 "+(props.class || "")}>{props.children}</div>;
const FooterNavHeader = (props) => <div class="text-sm font-bold text-uppercase uppercase upcase py-2 text-main-500">{props.children}</div>
const FooterLinksContainer = (props) => <div class="text-xs">{props.children}</div>
const FooterLink = (props) => <a href={props.href || "javasript:void(0);"} class="block text-xs py-1 text-link-500 hover:text-alt-link-500" onClick={e => window.scrollTo(0, 0)}>{props.children}</a>

const BWHoverImage = (props) => <div class="relative">
	<img src={props.src} class={"grayscale " + (props.class || "")} />
	<img src={props.src} class={"absolute top-0 left-0 opacity-0 hover:opacity-100 transition-opacity duration-200 " + (props.class || "")} />
</div>
